import { Id } from "./id";
import { z } from "zod";
export const ForgeProjectFile = z.object({
    id: z.string(),
    projectId: Id,
    name: z.string(),
    filePath: z.string(),
    createdAt: z.coerce.date().optional(),
    pendingUpload: z.boolean().optional(),
    size: z.number().int().positive().optional(),
    checksum: z.string(),
});
